import { PixiApp } from './pixi/PixiApp';
import { MusicManager } from './services/MusicManager';
import { InviteGate } from './pixi/components/InviteGate';

// Initialize the application when DOM is ready
document.addEventListener('DOMContentLoaded', async () => {
  const appContainer = document.getElementById('app');

  if (!appContainer) {
    throw new Error('App container not found');
  }

  // Check if user is already verified
  if (InviteGate.isVerified()) {
    // User already verified, start the game directly
    MusicManager.loadPreference();
    MusicManager.play();

    const pixiApp = new PixiApp();
    await pixiApp.init(appContainer);
  } else {
    // Show invite gate first
    const pixiApp = new PixiApp();
    await pixiApp.initWithInviteGate(appContainer, () => {
      // Callback when user is verified
      MusicManager.loadPreference();
      MusicManager.play();
    });
  }
});
